import type { Route } from "./+types/video";
import Page from "../pages/Video";
import { pageMeta } from "../lib/meta";
import { legacy } from "../lib/legacy";
import { OG_IMAGE } from "../config/heroArt";
export async function loader() { return { items: await legacy.podcasts() }; }
export const meta = () => pageMeta({ title: "Gazar Breakpoint | Podcast", description: "Gazar Breakpoint -- system design failures, architectural trade-offs, and the hard decisions that define senior engineering careers.", path: "/video", image: OG_IMAGE.podcast });
export default function R({ loaderData }: Route.ComponentProps) { return <Page items={loaderData.items} />; }
